import { Editor, Path, Transforms } from 'slate';
import { BLOCK_TABLE_ROW } from '../types';
import { getEmptyTableRow } from '../utils/get-empty-table-row';

export const insertRow = (editor, position) => {
  const currentRow = Editor.above(editor, {
    match: n => n.type === BLOCK_TABLE_ROW,
  });
  if (currentRow) {
    const [, rowPath] = currentRow;
    const [tableNode, tablePath] = Editor.parent(editor, rowPath);
    const col = tableNode.col;
    Transforms.insertNodes(editor, getEmptyTableRow(col), {
      at: position === 'top' ? rowPath : Path.next(rowPath),
      select: true,
    });
    const row = (tableNode.row) + 1;
    Transforms.setNodes(
      editor,
      {
        row,
      },
      {
        at: tablePath,
      },
    );
  }
};